import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUpdatePropertyMutation } from '../store/docApi';
import { Box, Button, Grid, Typography, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Add, Upload } from '@mui/icons-material';
import MotifBrowser from './MotifBrowser';
import MotifCard from './MotifCard';
import { generateEntityId, objectToArray } from '../utils';

export default function Motifs({ item }) {
  const navigate = useNavigate();
  const [updateProperty] = useUpdatePropertyMutation();
  const [isMotifDialogOpen, setIsMotifDialogOpen] = useState(false);
  const [isMotifBrowserOpen, setIsMotifBrowserOpen] = useState(false);
  const [newMotifId, setNewMotifId] = useState(generateEntityId('motif'));
  const [newMotif, setNewMotif] = useState({ name: '', data: [] });

  function onAddMotif() {
    setIsMotifDialogOpen(false);
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: `motifs/${newMotifId}`, value: { ...newMotif, id: newMotifId } });
    setNewMotif({ name: '', data: [] });
    setNewMotifId(generateEntityId('motif'));
  }

  function onSelectMotif(motif) {
    setIsMotifBrowserOpen(false);
    // Generate a new unique ID for the imported motif to avoid conflicts
    const newMotifId = generateEntityId('motif');
    const motifToImport = { ...motif, id: newMotifId };
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: `motifs/${newMotifId}`, value: motifToImport });
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Motifs
      </Typography>
      <Grid container spacing={2}>
        {item.motifs &&
          objectToArray(item.motifs).map((motif) => (
            <MotifCard
              key={motif.id}
              motif={motif}
              colors={item.colors || motif.colors}
              onClick={() => navigate(`/workspaces/${item.pk}/${item.id}/motifs/${motif.id}`)}
            />
          ))}
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" startIcon={<Add />} onClick={() => setIsMotifDialogOpen(true)} sx={{ mr: 2 }}>
          Add Motif
        </Button>
        <Button variant="outlined" startIcon={<Upload />} onClick={() => setIsMotifBrowserOpen(true)}>
          Import Motif
        </Button>
      </Box>

      {/* Add Motif Dialog */}
      <Dialog open={isMotifDialogOpen} onClose={() => setIsMotifDialogOpen(false)} fullWidth>
        <DialogTitle>Add New Motif</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            ID
          </Typography>
          <TextField
            value={newMotifId}
            onChange={(e) => setNewMotifId(e.target.value)}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
          <TextField
            label="Name"
            value={newMotif.name}
            onChange={(e) => setNewMotif({ ...newMotif, name: e.target.value })}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setIsMotifDialogOpen(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onAddMotif}>
            Add
          </Button>
        </DialogActions>
      </Dialog>

      {/* Import Motif Dialog */}
      <Dialog open={isMotifBrowserOpen} onClose={() => setIsMotifBrowserOpen(false)} fullWidth>
        <DialogTitle>Import Motif</DialogTitle>
        <DialogContent>
          <MotifBrowser onSelectMotif={onSelectMotif} onClose={() => setIsMotifBrowserOpen(false)} />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
